import React, { useState, useRef, useEffect } from 'react';
import styles from "./WhatsappMessagePreview.module.css";
import ThreeDots from "../../../Assets/Images/three-dots.png";
import Download from "../../../Assets/Images/download.png";
import { useDispatch } from "react-redux";
import {
  showSnackbarAction,
} from "../../../Redux/actions";

interface WhatsappMessagePreviewProps {
  selected: string | number;
  id: string | number;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  templateTitle: string;  
  showRadioButton?:any
  children: React.ReactNode;
  selectedTemplatesType?: any;
  templateData?: Record<string, unknown>;
  setShowDownload?: React.Dispatch<React.SetStateAction<string| number | null>>;
  showDownload?: string | number | null;
}

const WhatsappMessagePreview: React.FC<WhatsappMessagePreviewProps> = ({
  selected,
  id,
  handleChange,
  templateTitle,
  showRadioButton,
  children,
  selectedTemplatesType,
  templateData,
  setShowDownload,
  showDownload
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  // const handleClickOutside = (event: MouseEvent) => {
  //   if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
  //     setShowDownload && setShowDownload(null); // Hide the modal
  //   }
  // };

  // useEffect(() => {
  //   // Attach the click event listener
  //   document.addEventListener("mousedown", handleClickOutside);
    
  //   // Cleanup the event listener on component unmount
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);

  const dispatcher = useDispatch();

  const downloadTemplateSampleFile = (templateData: any) => {
    const fileUrl = `https://read-pro.s3.ap-south-1.amazonaws.com/templats/${templateData?.PH_HEADERS_FILE}`;
    if (templateData?.PH_HEADERS_FILE) {
      const fileName = "sample-file.csv";
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = fileName; // Suggests a filename for the download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setShowDownload && setShowDownload(null);
    }
    else {
      dispatcher(
        showSnackbarAction(
          "No sample file",
          "error"
        )
      );
      setShowDownload && setShowDownload(null);
      return;
    }
  }

  return (
    <div className={`${styles.whatsappTemplateCard} ${selected === id ? 'selectedCard' : ''}`}>
      <label className={`radioCard ${styles.whatsappTemplateRCard}`}>
        {
          (selectedTemplatesType === "Disposition based" || showRadioButton )&& (
            <>
              <input
                type="radio"
                name="radio"
                id={id.toString()}
                value={id.toString()}
                checked={selected === id}
                onChange={handleChange}
              />
              <span className={`checkmark ${styles.whatsappTemplatecheckmark}`}></span>
            </>
          )
        }
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div className={styles.whatsappTemplateTile}>{templateTitle}</div>
          <div style={{position:"relative"}} ref={modalRef}>
            { (selectedTemplatesType === "Broadcast Message" || showRadioButton )&& (
            <>
             <div style={{ padding: "0.25rem" }}>
              <img style={{ width: "1rem" }} src={ThreeDots} onClick={() => {
                setShowDownload && setShowDownload(id);
              }} />
            </div>
            {
              (showDownload === id) && (
                <div className={styles.downloadTemplate} onClick={(e)=>{
                  e.stopPropagation();
                  downloadTemplateSampleFile(templateData);
                }}>
                  <img style={{ width: "0.85rem" }} src={Download} />
                  <p>Download Sample File</p>
                </div>
              )
            }
            </>
          )}
            {/* <div style={{ padding: "0.25rem" }}>
              <img style={{ width: "1rem" }} src={ThreeDots} onClick={() => {
                setShowDownload && setShowDownload(id);
              }} />
            </div>
            {
              (showDownload === id) && (
                <div className={styles.downloadTemplate} onClick={(e)=>{
                  e.stopPropagation();
                  downloadTemplateSampleFile(templateData);
                }}>
                  <img style={{ width: "0.85rem" }} src={Download} />
                  <p>Download Sample File</p>
                </div>
              )
            } */}
          </div>
        </div>
        <div className={styles.whatsappTemplateContent}>
          {children}
        </div>
      </label>
    </div>
  );
};

export default WhatsappMessagePreview;
